import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {map, Observable} from "rxjs";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GraphService {

 //rutaGraphQl: string = 'https://0ehm5uf0oi.execute-api.us-east-2.amazonaws.com/dev/warehouse/graphql';

  //rutaGraphQl: string = 'http://localhost:3000/graphql';

  constructor(private http: HttpClient) { }

  public queryGraphQLSourcing<T>(options: {
    query: string;
    variables?: { [key: string]: any };
  }): Observable<T> {
    return this.http
      .post<{ data: T }>(`${environment.sourcingApi}/graphql`, {
        query: options.query,
        variables: options.variables,
      })
      .pipe(map((d) => d.data));

  }

  public queryGraphQLSales<T>(options: {
    query: string;
    variables?: { [key: string]: any };
  }): Observable<T> {
    return this.http
      .post<{ data: T }>(`${environment.salesApi}/graphql`, {
      //.post<{ data: T }>('http://localhost:3000/graphql', {
        query: options.query,
        variables: options.variables,
      })
      .pipe(map((d) => d.data));

  }

  public mutateGraphQLSales<T>(options: {
    mutation: string;
    variables?: { [key: string]: any };
  }): Observable<any> {
    return this.http
      .post<{ data: T }>(`${environment.salesApi}/graphql`, {
      //.post<{ data: T }>('http://localhost:3000/graphql', {
        query: options.mutation,
        variables: options.variables,
      })
      .pipe(map((d) => d.data));
  }

  public queryGraphQLAlmacen<T>(options: {
    query: string;
    variables?: { [key: string]: any };
  }): Observable<T> {
    return this.http
    //.post<{ data: T }>('http://localhost:3000/graphql', {
      .post<{ data: T }>(`${environment.warehouseApi}/graphql`, {
        query: options.query,
        variables: options.variables,
      })
      .pipe(map((d) => d.data));
    /*
          console.log('getalldata service GQL',); */
  }



  public queryGraphQLProduct<T>(options: {
    query: string;
    variables?: { [key: string]: any };
  }): Observable<T> {
    return this.http
      .post<{ data: T }>(`${environment.productApi}/graphql`, {
        query: options.query,
        variables: options.variables,
      })
      .pipe(map((d) => d.data));
    /*
          console.log('getalldata service GQL',); */
  }

  public mutateGraphQLProduct<T>(options: {
    mutation: string;
    variables?: { [key: string]: any };
  }): Observable<any> {
    return this.http
      .post<{ data: T }>(`${environment.productApi}/graphql`, {
        // .post<{ data: T }>('http://localhost:3000/graphql', {
        query: options.mutation,
        variables: options.variables,
      })
      .pipe(map((d) => d.data));
  }
  
  public mutateGraphQLAlmacen<T>(options: {
    mutation: string;
    variables?: { [key: string]: any };
  }): Observable<any> {
    return this.http
      .post<{ data: T }>(`${environment.warehouseApi}/graphql`, {
        // .post<{ data: T }>('http://localhost:3000/graphql', {
        query: options.mutation,
        variables: options.variables,
      })
      .pipe(map((d) => d.data));
  }


}
